export default __webpack_public_path__ + "static/media/report2.eb16123c.svg";